<template>
  <div>
    <div class="page_header">
      <div class="header_top media_display">
        <div class="container_box header_top">
          <div class="row">
            <div class="fl top_left">
              <span>欢迎来到日照人力资源服务产业园！</span>
              <span>{{$moment(new Date()).format('ll')}} &nbsp;&nbsp;{{$moment(new Date()).format('dddd')}}</span>
            </div>
            <div class="fr ar top_right">
              <div v-if="isLogin==null">
                <a class="xbtn lang_login" @click='goLogin'>登录</a> |
                <a class="lang_register" @click="goRegister">注册</a>
              </div>
              <div id="topEnterBox" @mouseover="topEnterShow=true" @mouseout="topEnterShow=false">
                <div v-if="isLogin!=null" class="enterInfo" id="enterInfo" @click="openNews">
                  <div class="img_box">
                    <img src="../assets/images/user-avatar.png" v-if="loginType==3">
                    <img :src="companyLogo" v-if="loginType!=3">                   
                  </div>
                  <div>{{username}}</div>
                </div>
                <ul class="enterInfolist" id="enterInfolist" v-show='topEnterShow'> 
                  <li @click="toEntercenter" v-if="loginType!=3">企业中心</li>
                  <li @click="toEnterpercenter" v-else-if="loginType==3">个人中心</li>
                  <li @click="getQuit">退出登录</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header_nav">
        <div class="container_box bg_white">
          <div class="row">
            <div class="logo_box fl">
              <router-link to="/" tag="a">
                <img src="../assets/images/logo.jpg" alt="">
              </router-link>
            </div>
            <div class="nav_box fr media_display">
              <router-link to="/" :class="{'active':currentPath=='/'}">首页</router-link>
              <router-link to="/in-park" :class="{'active':currentPath=='/in-park'}">走进园区</router-link>
              <!-- <router-link to="/canvass-business" :class="{'active':currentPath=='/canvass'}">智慧招商</router-link> -->
              <router-link to="/new-enter-park":class="{'active':currentPath=='/enter-p'}">企业入园</router-link>
              <router-link to="/news-info" :class="{'active':currentPath=='/news-in'}">新闻资讯</router-link>
              <router-link to="/park-serve" :class="{'active':currentPath=='/park-se'}">园区服务</router-link>
              <a @click='goTrade'>交易平台</a>              
              <router-link to="/park-build" :class="{'active':currentPath=='/park-bu'}">园区党建</router-link>
              <router-link to="/base" :class="{'active':currentPath=='/two-bas'}">双创基地</router-link>
              <router-link to="/search"><img src="../assets/images/icon-search.jpg" alt=""></router-link>
            </div>
            <div class="media_nav_icon fr" @click='smallScreen = true'><img src="../assets/images/icon_nav.png" alt=""></div>
            <div class="media_nav_box" v-show="smallScreen">
              <div class="btn_close" @click="smallScreen = false"><img src="../assets/images/icon_close.png" alt=""></div>
              <div class="nav_main">
                  <router-link to="/" :class="{'active':currentPath=='/'}" @click.native="smallScreen=false">首页</router-link>
                  <router-link to="/in-park" :class="{'active':currentPath=='/in-park'}" @click.native="smallScreen=false">走进园区</router-link>
                  <router-link to="/new-enter-park":class="{'active':currentPath=='/enter-p'}" @click.native="smallScreen=false">企业入园</router-link>
                  <router-link to="/news-info" :class="{'active':currentPath=='/news-in'}" @click.native="smallScreen=false">新闻资讯</router-link>
                  <router-link to="/park-serve" :class="{'active':currentPath=='/park-se'}" @click.native="smallScreen=false">园区服务</router-link>
                  <a @click='goTrade' @click.native="smallScreen=false">交易平台</a>              
                  <router-link to="/park-build" :class="{'active':currentPath=='/park-bu'}" @click.native="smallScreen=false">园区党建</router-link>
                  <router-link to="/base" :class="{'active':currentPath=='/two-bas'}" @click.native="smallScreen=false">双创基地</router-link>
                  <router-link to="/search" @click.native="smallScreen=false"><img src="../assets/images/icon-search.jpg" alt="" ></router-link>
              </div>
              <div class="login">
                <div v-if="isLogin==null">
                  <a @click='goLogin'>登录</a>
                  <a @click="goRegister">注册</a>
                </div>
                <div v-else>
                  <div class="avatar" @click="goMine">
                    <div class="img_box">
                      <img src="../assets/images/logo_s.png" v-if="loginType==3">   
                      <img :src="companyLogo" v-if="loginType!=3">  
                    </div>
                    <div>{{username}}</div>
                  </div>
                  <a @click="getQuit">退出登录</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      smallScreen:false,
      isLogin: null,
      username: "",
      loginType: "1",
      companyLogo: "",
      topEnterShow: false,
      navIndex:0,
    };
  },
  methods: { 
    //中英文切换 
    tabEn: function () {
      if(this.$i18n.locale=='zh'){
        this.$i18n.locale = 'en' 
      }else{       
        this.$i18n.locale = 'zh' 
      }    
    }, 
    // 初始化页面头部数据
    getLoginData() {
      if (localStorage.getItem("token") != null) {
        this.isLogin = localStorage.getItem("token");
        this.username = localStorage.getItem("username");
        this.loginType = localStorage.getItem("type");
        this.companyLogo = localStorage.getItem("logo");
      }
    },
    goLogin() {
      this.$router.push("/login");
    },
    goRegister(){
      this.$router.push("/register");
    },
    toEntercenter(){
      this.$router.push('/etprise-center/info')
    },
    toEnterpercenter(){
      this.$router.push('/person-center')
    },
    goMine(){
      if(this.loginType==3){
        this.$router.push('/person-center')
      }else{
        this.$router.push('/etprise-center/info')
      }
      this.smallScreen = false;
    },
    // 退出登录
    getQuit() {
      this.$confirm('您确定要退出登录?', '退出登录', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.clear();
        location.reload();
      }).catch(() => {         
      });
    },
    goTrade(){
      let newpage = this.$router.resolve({ 
            name: 'trade-index', 
      })
      window.open(newpage.href, '_blank');
    },
    openNews(){
      if(sessionStorage.getItem('unReadnum')>0 ){
        if(localStorage.getItem('type')==3){     
          window.sessionStorage.setItem("personCenterType",2)
          this.$router.push({path:'/person-center'});
        }
        if(localStorage.getItem('type')!=3){
          window.sessionStorage.setItem("enterCenterType",7)
          this.$router.push({path:'/enter-center'});
        }
      }
      
    },
  },
  destroyed () {
  },
  computed:{
    currentPath(){
      return this.$route.path.substring(0,8);
    }
  },
  created() {
    this.getLoginData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/topHeaderNew.vue